import { Container, Typography, createStyles, makeStyles } from '@material-ui/core';
import * as React from 'react';
import NoDebts from '../../assets/images/NoDebts';
import { Title } from '../../components/Titles/Title';
import { CssSpreadType } from '../../utils/css-spread-type';
import thousandSeparator from '../../utils/thousandSeparator';
import { TranquiTheme } from '../App/theme';
import PortalBase from './PortalBase';

interface PortalNoOutDebtsProps {
  document?: string;
}

const PortalNoOutDebts: React.FC<PortalNoOutDebtsProps> = ({ document }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <PortalBase>

      <Title
        title="NEGOCIACIÓN DE DEUDA"
        subtitle="¡Hola, bienvenido!"
      />

      <Container
        className={classes.container}
      >
        <NoDebts />
        <Typography className={classes.text} variant="h4" align="center">
          En estos momento no encontramos una alternativa para ti
        </Typography>
        {document && (
          <Typography className={classes.result} align="center">
            Para tu documento <strong>{thousandSeparator(document)}</strong> no encontramos
            {' '}
            en este momento una alternativa Pre-aprobada por uno de nuestros bancos aliados.
            {' '}
            Te notificaremos a tu celular cuando encontremos una opción para ti.
          </Typography>
        )}
      </Container>

    </PortalBase>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: theme.palette.indigo.main,
    fontWeight: 'bold',
  },
  result: {
    ...(theme.typography.small as CssSpreadType),
    color: theme.palette.text3.main,
    padding: '1em 3em',
    maxWidth: 790,
  },
  mobile: {
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
}));

export default PortalNoOutDebts;
